import { getAllQueue, removeFromQueue } from "./offline_queue";
import { showPwaFlash } from "./show_pwa_flash";

let isSyncing = false

export async function syncQueue() {
    if (!navigator.onLine) return
    if (isSyncing) return

    isSyncing = true

    const queue = await getAllQueue()
    let successCount = 0

    for (const item of queue) {
        try {
            let url = ""
            let method = "POST"

            if (item.type === "clock_in") {
                url = "/attendances/clock_in"
                method = "POST"
            } else if (item.type === "clock_out") {
                url = "/attendances/clock_out"
                method = "PATCH"
            }

            const formData = new FormData()

            Object.entries(item.payload).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach(v => formData.append(key, v))
                } else {
                    formData.append(key, value)
                }
            })

            const response = await fetch(url, {
                method,
                headers: {
                    "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.getAttribute("content"),
                    "Accept": "application/json"
                },
                body: formData
            })

            if (response.ok) {
                await removeFromQueue(item.id)
                successCount++
            } else {
                console.error("Sync failed", response.status)
            }

        } catch (error) {
            console.error("Sync error", error)
            break
        }
    }

    if (successCount > 0) {
        showPwaFlash(`${successCount}出席状況が正常に保存されました`, "success")
    }

    isSyncing = false
}